// Strips the leading "Payment Terms: ...." sentence from a free-text T&C
// block. The default terms_templates row always opens with this sentence,
// which duplicates (and often contradicts) the dedicated Payment Terms
// field/table shown elsewhere on the same document.
const PAYMENT_TERMS_SENTENCE_RE = /^\s*Payment Terms:\s*[^.]*\.\s*/i;

export const stripDefaultPaymentTermsSentence = (text?: string | null): string =>
    (text ?? '').replace(PAYMENT_TERMS_SENTENCE_RE, '').trim();
